var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavingDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4557_369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76504 22.847H2.8291V24.8755H5.76504V22.847Z",
    fill: "#114289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5446 22.847H24.6086V24.8755H27.5446V22.847Z",
    fill: "#114289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5588 22.7936H1.54813C0.747417 22.7936 0.0534668 22.153 0.0534668 21.2989V9.28824C0.0534668 8.48753 0.694036 7.79358 1.54813 7.79358H28.5588C29.3595 7.79358 30.0535 8.43415 30.0535 9.28824V21.3523C30.0535 22.153 29.3595 22.7936 28.5588 22.7936Z",
    fill: "url(#paint0_linear_4557_369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0428 20.7117H3.41648C2.77591 20.7117 2.18872 20.1779 2.18872 19.484V11.1566C2.18872 10.516 2.72253 9.92883 3.41648 9.92883H18.0428C18.6834 9.92883 19.2706 10.4626 19.2706 11.1566V19.5374C19.2706 20.1779 18.7368 20.7117 18.0428 20.7117Z",
    fill: "#9BC3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8221 18.2028C26.2962 18.2028 27.4912 17.0079 27.4912 15.5338C27.4912 14.0597 26.2962 12.8647 24.8221 12.8647C23.348 12.8647 22.1531 14.0597 22.1531 15.5338C22.1531 17.0079 23.348 18.2028 24.8221 18.2028Z",
    fill: "#9BC3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.822 17.242C25.7654 17.242 26.5301 16.4772 26.5301 15.5338C26.5301 14.5904 25.7654 13.8256 24.822 13.8256C23.8786 13.8256 23.1138 14.5904 23.1138 15.5338C23.1138 16.4772 23.8786 17.242 24.822 17.242Z",
    fill: "#114289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.331 17.3488C12.1708 17.6157 12.0107 17.7758 11.7438 17.9893C11.4769 18.1495 11.1566 18.2562 10.7829 18.3096V19.0036H10.2491V18.3096C9.71531 18.2562 9.28826 18.0961 8.96798 17.8292C8.64769 17.5623 8.48755 17.1886 8.48755 16.7082H9.50178C9.50178 16.9217 9.60855 17.0819 9.71531 17.242C9.82207 17.4021 10.0356 17.4555 10.2491 17.5089V15.694C9.87545 15.5872 9.55516 15.4804 9.34164 15.427C9.12812 15.3203 8.9146 15.1601 8.75445 14.9466C8.59431 14.7331 8.48755 14.4662 8.48755 14.0925C8.48755 13.6121 8.64769 13.2384 8.96798 12.9715C9.28826 12.7046 9.71531 12.4911 10.2491 12.4377V11.7438H10.7829V12.4377C11.2633 12.4911 11.637 12.6512 11.9573 12.9182C12.2776 13.1851 12.4377 13.5587 12.4377 13.9858H11.4235C11.4235 13.8256 11.3167 13.6655 11.21 13.5053C11.1032 13.3452 10.9431 13.2918 10.7295 13.2384V14.9466C11.1032 15.0534 11.4235 15.1068 11.637 15.2135C11.8505 15.3203 12.0641 15.4804 12.2242 15.694C12.3843 15.9075 12.4911 16.1744 12.4911 16.548C12.4911 16.8683 12.4377 17.0819 12.331 17.3488ZM9.66193 14.5196C9.82207 14.6263 9.98221 14.7331 10.2491 14.8399V13.1851C10.0356 13.2384 9.82207 13.2918 9.66193 13.452C9.50178 13.6121 9.4484 13.7722 9.4484 14.0391C9.4484 14.1993 9.50178 14.4128 9.66193 14.5196ZM11.3701 17.1886C11.5303 17.0285 11.5836 16.8149 11.5836 16.6014C11.5836 16.3879 11.5303 16.2278 11.3701 16.0676C11.21 15.9609 11.0498 15.8541 10.7829 15.7473V17.4555C10.9964 17.4555 11.21 17.3488 11.3701 17.1886Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4557_369",
    x1: 15.0535,
    y1: 7.79358,
    x2: 15.0535,
    y2: 22.7936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056BED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4557_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.0534,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingDesktop);
export default __webpack_public_path__ + "static/media/saving-desktop.f49a657b476d7e8f7992ad6dc3a548c1.svg";
export { ForwardRef as ReactComponent };